<script setup>
import {computed, defineEmits, defineProps} from "vue";

const emit = defineEmits(["hide-date-picker", "update-date"]);

const props = defineProps({
  /** Файл локализации */
  localeMessages: {
    type: Object,
    required: true
  }
});

const cancelButtonText = computed(() => props.localeMessages.buttons.cancel);
const selectButtonText = computed(() => props.localeMessages.buttons.select);
</script>

<template>
  <div class="date-control">
    <button
      class="date-control__button date-control__button--decline"
      @click="emit('hide-date-picker')"
    >
      {{ cancelButtonText }}
    </button>
    <button
      class="date-control__button date-control__button--accept"
      @click="emit('update-date')"
    >
      {{ selectButtonText }}
    </button>
  </div>
</template>

<style scoped lang="scss">
.date-control {
  display: flex;
  gap: 14px;

  &__button {
    box-sizing: border-box;
    padding: 6px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    border: none;
    line-height: 18px;
    height: 36px;
    cursor: pointer;
    user-select: none;

    &--decline {
      color: #373D3F;
      background: #F7F8FD;

      &:hover {
        color: #1F9AFF;
      }
    }

    &--accept {
      background: #1A64D4;
      color: #F7F8FD;

      &:hover {
        background: #1658BC;
      }
    }

  }
}

</style>